export enum ActivationDataEventObject {
  TRIGGERED_SUGGESTION_VIEW = 'triggered_suggestion_view',
  TRIGGERED_SUGGESTION_ACTION = 'triggered_suggestion_action',
  ADMIN_SUGGESTIONS = 'admin_suggestions',
  ADMIN_COMMAND_CENTER_P0_SUGGESTION = 'admin_command_center_p0_suggestion',
  BANNER = 'banner',
  TIP = 'tip',
  TIP_PRIMARY = 'tip_primary',
  TIP_CLOSE = 'tip_close',
  CONFIGURE_AI_WORKSPACE_SETTINGS_SELECT_INBOXES_TIP = 'configure_ai_workspace_settings_select_inboxes_tip',
  CONFIGURE_AI_WORKSPACE_SETTINGS_TRY_AUTOPILOT_TIP = 'configure_ai_workspace_settings_try_autopilot_tip',
  CONFIGURE_AI_WORKSPACE_SETTINGS_CONFIGURE_AUTOPILOT_TOPICS_TIP = 'configure_ai_workspace_settings_configure_autopilot_topics_tip',
  CONFIGURE_AI_WORKSPACE_SETTINGS_ADD_SOURCES_TIP = 'configure_ai_workspace_settings_add_sources_tip',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_TIP = 'configure_ai_copilot_knowledge_base_tip',
  APPLICATION_KNOWLEDGE_SOURCE_TIP_NOTION = 'application_knowledge_source_tip_notion',
  APPLICATION_KNOWLEDGE_SOURCE_TIP_GDRIVE = 'application_knowledge_source_tip_gdrive',
}
